import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { ServerError } from "~types/types";

const initialState: ServerError = {};

const serverErrorSlice = createSlice({
    name: "serverError",
    initialState,
    reducers: {
        serverErrorSet(state, action: PayloadAction<ServerError>) {
            Object.assign(state, action.payload);
        },
    },
});

export const { serverErrorSet } = serverErrorSlice.actions;

export default serverErrorSlice.reducer;
